module.exports = __webpack_public_path__ + "img/Notes.1ac5544d.svg";